// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ih-vE","tooltip":"styles_tooltip__CEKMW","tooltipText":"styles_tooltipText__cTQod","info":"styles_info__0+qNw"};